import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { T as x } from "./index-BlBizyO0.mjs";
import { g as y } from "./get-aria-describedby-G1wcWKF2.mjs";
import { u as T } from "./use-rhf-wrapper-controller-DGFm3TD5.mjs";
import { t as R } from "./toggle-rhf-rules-Z1TdwfO9.mjs";
import { c as j } from "./combine-function-calls-C5qD-ZYI.mjs";
const F = (o) => {
  const e = {
    ...o,
    value: ["%"]
  };
  return e.value.unshift(e.currencySymbol || "$"), /* @__PURE__ */ i.jsx(x, { ...e, "data-fabric-component": "CurrencyToggle", value: e.value });
};
function W({
  ariaDescribedby: o,
  control: e,
  defaultValue: l = "%",
  disabled: r = !1,
  currencySymbol: n,
  errorMessageId: u,
  name: t,
  onBlur: c,
  onChange: a,
  shouldUnregister: f,
  validate: g,
  ...m
}) {
  const { field: p, fieldState: C } = T({
    control: e,
    defaultValue: l,
    name: t,
    // This is a workaround for `disabled` because it is not available in `useController` yet (not available until v7.48.0).
    rules: R({ validate: g }, r),
    shouldUnregister: f
  }), { onBlur: d, onChange: v, value: b } = p;
  function h(B, { value: s }) {
    v(s), typeof a == "function" && a(s);
  }
  return /* @__PURE__ */ i.jsx(
    F,
    {
      ...m,
      ariaDescribedby: y(C.error ? u : void 0, o),
      currencySymbol: n,
      isChecked: b === n,
      isDisabled: r,
      name: t,
      onBlur: j(d, c),
      onChange: h
    }
  );
}
export {
  W as C,
  F as a
};
//# sourceMappingURL=currency-toggle-rhf-DmQDw826.mjs.map
